import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Login from "./pages/login";
import Chat from './pages/chat';
import SignUp from './pages/signUp';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import ForgotPassword from './pages/forgot-password';
import ResetPassword from './pages/reset-password';
import Admin from './pages/admin';
import Dashboard from './pages/dashboard';
import VeteransPortal from './pages/veterans-portal';
import { useQueryParamHandler } from './utils/apis/api';

function App() {

  useQueryParamHandler();

  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/signup" element={<SignUp />} />
      <Route path="/chat" element={<Chat />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/veterans-portal" element={<VeteransPortal />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function Root() {
  return (
    <Router>
      <App />
    </Router>
  );
}
